import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalContent,
  ModalOverlay,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  Input,
  ModalFooter,
  Select,
} from "@chakra-ui/react";

import { SiGnuprivacyguard } from "react-icons/si";
import { images } from "../../src/dummyData";

export default class ModalBox extends Component {
  state = {
    textInput: "",
    // backgroundImg: "hhh",
  };

  render() {
    console.log(this.state.backgroundImg);

    console.log(this.props);
    return (
      <div>
        <Modal
          isOpen={this.props.open}
          onClose={this.props.close}
          closeOnEsc={true}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader
              style={{
                marginLeft: "100px",
                fontSize: "20px",
                fontWeight: "normal",
                color: "#557B83",
              }}
            >
              Create new Board
            </ModalHeader>
            <hr />
            <ModalCloseButton />
            <ModalBody pb={6}>
              <img
                src="https://a.trellocdn.com/prgb/dist/images/board-preview-skeleton.14cda5dc635d1f13bc48.svg"
                alt=""
                role="presentation"
                style={{ marginLeft: "92px" }}
              />
              <div
                style={{
                  marginTop: "15px",
                  fontSize: "14px",
                  color: "#393E46",
                }}
              >
                Select background Image
              </div>
              <div style={{ display: "flex", padding: "20px" }}>
                {images.map((item) => {
                  return (
                    <div
                      style={{ margin: "5px" }}
                      onClick={() => this.props.setImageBackground(item)}
                    >
                      {" "}
                      <img
                        src={item}
                        alt="BordImage"
                        width="50px"
                        height="50px"
                      />
                    </div>
                  );
                })}
              </div>

              <FormControl mt={4}>
                <FormLabel
                  style={{
                    margin: "5px",
                    marginTop: "15px",
                    fontSize: "14px",
                    color: "#393E46",
                  }}
                >
                  Board Title
                </FormLabel>
                <Input
                  placeholder="input baord name "
                  value={this.state.textInput}
                  onChange={(e) => this.setState({ textInput: e.target.value })}
                  required={true}
                />
              </FormControl>
              <div
                style={{
                  margin: "5px",
                  marginTop: "15px",
                  fontSize: "14px",
                  color: "#393E46",
                }}
              >
                Select Visibility
              </div>
              <Select placeholder="workspace">
                <option
                  value="option1"
                  style={{
                    margin: "5px",
                    marginTop: "15px",
                    fontSize: "14px",
                    color: "#393E46",
                  }}
                >
                  WorkSpace
                </option>
                <option
                  value="option2"
                  style={{
                    margin: "5px",
                    marginTop: "15px",
                    fontSize: "14px",
                    color: "#393E46",
                  }}
                >
                  {" "}
                  Private
                </option>
                <option
                  value="option3"
                  style={{
                    margin: "5px",
                    marginTop: "15px",
                    fontSize: "14px",
                    color: "#393E46",
                  }}
                >
                  Public
                </option>
              </Select>

              <div
                style={{
                  margin: "5px",
                  padding: "5px",
                  fontSize: "14px",
                  color: "#A7BBC7",
                }}
              >
                This Workspace has 6 boards remaining. Free Workspaces can only
                have 10 open boards. For unlimited boards, upgrade your
                Workspace.
              </div>
            </ModalBody>

            <ModalFooter>
              <Button
                colorScheme="blue"
                mr={3}
                onClick={() => this.props.handleSave(this.state.textInput)}
                style={{ backgroundColor: "#87A7B3", width: "100%" }}
              >
                Create
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </div>
    );
  }
}
